const VK_PAGES_URL = ['/lp/retail/debit/promo/iframe/'];

const getVkScript = url => {
    return VK_PAGES_URL.includes(url)
        ? `<script src="https://unpkg.com/@vkontakte/vk-bridge/dist/browser.min.js"></script>
            <script>
                if (window.vkBridge) {
                    vkBridge.send('VKWebAppInit');
                }
            </script>`
        : '';
};

module.exports = {
    getVkScript
};
